import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import styles from './multiline-text.module.scss';

export default function AgGridMultilineText({ value, valueFormatted }: ICellRendererParams) {
  const valueToShow = valueFormatted ?? value;

  return (
    <div className={styles.wrapper}>
      {valueToShow}
    </div>
  );
}
